import * as Yup from 'yup';

const phoneExpression = new RegExp(/[+]?[0-9]?[0-9]{8,10}/);
const postcodeExpression = new RegExp(/^[0-9]{4}$/);
const wordLimitExpression = new RegExp(/\S+/g);

const errorMessages = {
  required: 'This is a required field',
  email: 'Please enter a valid email address',
  requiredTC: 'Must accept the terms and conditions',
  requiredNewsletter: 'Must opt in to newsletter',
  requiredAge: 'Must confirm age requirement',
  phone: 'Invalid number',
  postcode: 'Invalid postcode',
  wordLimit: 'Limit of 25 words',
};

export const wordLimit = (value, limit) => {
  if (!limit || !value) return true;
  const count = value.match(wordLimitExpression).length;
  return count <= 25;
};

const getConfig = ({ textAreaLimitWords }) => ({
  showDob: {
    initialState: '',
    id: 'birthday',
    validation: Yup.string().required(errorMessages.required),
  },
  showCountries: {
    initialState: 'AU',
    id: 'nationality',
    validation: Yup.string().required(errorMessages.required),
  },
  showEmail: {
    initialState: '',
    id: 'email',
    validation: Yup.string()
      .email(errorMessages.email).required(errorMessages.required),
  },
  showFirstName: {
    initialState: '',
    id: 'firstname',
    validation: Yup.string().required(errorMessages.required),
  },
  showGender: {
    initialState: 'female',
    id: 'gender',
    validation: Yup.string().required(errorMessages.required),
  },
  showInterests: {
    initialState: [],
    id: 'interests',
    validation: Yup.array(),
  },
  showLastName: {
    initialState: '',
    id: 'lastname',
    validation: Yup.string().required(errorMessages.required),
  },
  showPhoneNumber: {
    initialState: '',
    id: 'phonenumber',
    validation: Yup.string()
      .matches(phoneExpression, errorMessages.phone)
      .required(errorMessages.required),
  },
  showPostcode: {
    initialState: '',
    id: 'postcode',
    validation: Yup.string()
      .matches(postcodeExpression, errorMessages.postcode)
      .required(errorMessages.required),
  },
  showTextArea: {
    initialState: '',
    id: 'story',
    validation: Yup.string()
      .trim()
      .test('limit-word-count', errorMessages.wordLimit, value => wordLimit(value, textAreaLimitWords))
      .required(errorMessages.required),
  },
  tc: {
    initialState: false,
    id: 'tc',
    validation: Yup.bool()
      .oneOf([true], errorMessages.requiredTC).required(errorMessages.requiredTC),
  },
  newsletter: {
    initialState: false,
    id: 'newsletter',
    validation: Yup.bool()
      .oneOf([true], errorMessages.requiredNewsletter).required(errorMessages.requiredNewsletter),
  },
  thirdParty: {
    initialState: false,
    id: 'thirdParty',
  },
  age: {
    initialState: false,
    id: 'age',
    validation: Yup.bool()
      .oneOf([true], errorMessages.requiredAge).required(errorMessages.requiredAge),
  },
});

export default getConfig;
